<template>
  <section>
    <Espaco :segmento="segmento"/>
    <br>
    <Materiais :segmento="segmento"/>
    <br>
    <Seguro/>
    <br>
    <Uniforme/>
    <br>
    <Convenios/>
  </section>
</template>

<script>
import Convenios from "../lateral/Convenios";
import Uniforme from "../lateral/Uniforme";
import Seguro from "../lateral/Seguro";
import Espaco from "../lateral/Espaco";
import Materiais from "../lateral/Materiais";

export default {
  props: { segmento: Number },
  data: () => ({}),
  components: {
    Convenios,
    Uniforme,
    Seguro,
    Espaco,
    Materiais
  }
};
</script>

<style lang="scss" scoped>
p,
h2,
ul li,
ol li {
  text-align: left !important;
}
</style>



